<template>
    <div>
        <category-form
        :is-cat-form-sidebar-active.sync="isCatFormSidebarActive"
            :category-data="catData"
            @refetch-data="refetchData" 
         />
        <b-card no-body>
            <div class="m-2">
                <b-row>
                    <b-col
                        cols="12"
                        md="6"
                        class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
                    >
                    </b-col>
                    <b-col
                        cols="12"
                        md="6"
                    >
                        <div class="d-flex align-items-center justify-content-end">
                            <b-form-input
                                v-model="searchQuery"
                                class="d-inline-block mr-1"
                                placeholder="Search..."
                            />
                            <b-button
                            variant="primary"
                            @click="updateCat()"
                         
                            >
                                <span class="text-nowrap">Add Category</span>
                            </b-button>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <b-table
                v-if="!cats.length"
                :items="cats"
                responsive
                :fields="tableColumns"
                show-empty
                empty-text="No matching records found"
                class="position-relative"
            >
            </b-table>
            <table v-else class="table table-striped">
            <thead>
                <tr>
                <th scope="col" v-for="col in tableColumns">
                    {{col.label}}
                </th>
                </tr>
            </thead>
            <draggable v-model="cats" tag="tbody" hadle=".handle" @change="updateCategoryOrdering()">
                <tr v-for="(item, index) in cats" :key="index">
                    <th scope="row" class="pl-2">
                        <MenuIcon icon="MenuIcon" class="handle"/>
                    </th>
                    <td class="pl-2">
                        <span>{{item.title}}</span>
                    </td>
                    <td class="pl-2">
                        <span>{{item.slug}}</span>
                    </td>
                    <td class="pl-2">
                        <b-badge
                        pill
                        :variant="`light-${resolveCatStatusVariant(item.is_active)}`"
                        class="text-capitalize"
                        >
                            {{ resolveCatStatusnameVariant(item.is_active) }} 
                        </b-badge>
                    </td>
                    <td class="pl-2">
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'"  @click="updateCat(item)" variant="outline-success">Edit</b-button>
                        <b-button  v-ripple.400="'rgba(113, 102, 240, 0.15)'" class="ml-1" @click="deleteconfirm(item.id)" variant="outline-danger">Delete</b-button>
                    </td>
                </tr>
            </draggable>
            </table>

            <div class="mx-2 mb-2">
                <b-row>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-start"
                    >
                        <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
                    </b-col>
                    <b-col
                        cols="12"
                        sm="6"
                        class="d-flex align-items-center justify-content-center justify-content-sm-end"
                    >
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="totalCats"
                            :per-page="perPage"
                            first-number
                            last-number
                            class="mb-0 mt-1 mt-sm-0"
                            prev-class="prev-item"
                            next-class="next-item"
                        >
                            <template #prev-text>
                                <feather-icon
                                    icon="ChevronLeftIcon"
                                    size="18"
                                />
                                </template>
                                <template #next-text>
                                <feather-icon
                                    icon="ChevronRightIcon"
                                    size="18"
                                />
                            </template>
                        </b-pagination>
                    </b-col>
                </b-row>
            </div>
        </b-card>
    </div>
    </template>
    <script>
    import {
      BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,BImg,
      BBadge, BDropdown, BDropdownItem, BPagination, BTooltip,VBModal,BFormGroup,BFormCheckbox
    } from 'bootstrap-vue'
    import draggable from 'vuedraggable'
    import Ripple from 'vue-ripple-directive'
    //api
    import axios from '@axios'
    import store from '@/store'
    import { ref,onUnmounted } from '@vue/composition-api'
    
    
    import useCategoryList from './useCategoryList'
    import socialsStoreModule from '../socialsStoreModule'
    import CategoryForm from './CategoryForm.vue'
    import { MenuIcon } from 'vue-feather-icons'
    
    export default {
        components:{
            BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink, BImg,
            BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, VBModal, BFormGroup, BFormCheckbox,
            CategoryForm, draggable, MenuIcon
        },
        directives:{
            'b-modal': VBModal,
            Ripple
    
        },
        setup() {
            const CAT_STORE_MODULE_NAME = 'app-socials';
            if (!store.hasModule(CAT_STORE_MODULE_NAME)) store.registerModule(CAT_STORE_MODULE_NAME, socialsStoreModule)
            onUnmounted(() => {
                if (store.hasModule(CAT_STORE_MODULE_NAME)) store.unregisterModule(CAT_STORE_MODULE_NAME)
            });
            const {
                cats,
                catData,
                isCatFormSidebarActive,
                refCatListTable,
                tableColumns,
                perPage,
                totalCats,
                currentPage,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                statusFilter,
                dataMeta,
                refetchData,
                fetchData,
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                updateCat,
                deleteData,
                updateCategoryOrdering
            } = useCategoryList();

            fetchData();
            return {
                cats,
                catData,
                isCatFormSidebarActive,
                refCatListTable,
                tableColumns,
                perPage,
                totalCats,
                currentPage,
                perPageOptions,
                searchQuery,
                sortBy,
                isSortDirDesc,
                statusFilter,
                dataMeta,
                refetchData,
                fetchData,
                resolveCatStatusVariant,
                resolveCatStatusnameVariant,
                updateCat,
                deleteData,
                updateCategoryOrdering
            }
        },
        methods:{
            handleChange() {
    },
    inputChanged(value) {
      this.activeNames = value;
    },
    getComponentData() {
      return {
        on: {
          change: this.handleChange,
          input: this.inputChanged
        },
        attrs:{
          wrap: true
        },
        props: {
          value: this.activeNames
        }
      };
    },
            changeOrdering(){
                // console.log('test');
            },
            deleteconfirm(id){
                this.$bvModal
                    .msgBoxConfirm('Please confirm that you want to delete User ID.'+id, {
                    title: 'Please Confirm',
                    size: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    cancelVariant: 'outline-secondary',
                    hideHeaderClose: false,
                    centered: true,
                    })
                    .then(value => {
                    if(value === true){
                    this.deleteData(id)
                    }
                
                    //this.deleteData(id)
                    })
    
            },
        }
    }
    </script>

<style scoped lang="scss">

.img_property{
    width: 150px;
    height: 100px;
}
</style>